import React, { useState } from "react";
import { Tab } from "@headlessui/react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { toggleTheme, setTheme } from "../store/slices/themeSlice";
import {
  PaintBrushIcon,
  BellIcon,
  ShieldCheckIcon,
  UserIcon,
  GlobeAltIcon,
  BuildingOfficeIcon,
  KeyIcon,
  Cog6ToothIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import PageWrapper from "@/components/common/PageWrapper";



const NotificationSettings: React.FC = () => {
  return (
    <PageWrapper >
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900 dark:text-white">
          Notification Preferences
        </h3>
        <p className="mt-1 text-sm text-secondary-500 dark:text-secondary-400">
          Choose how you want to be notified about updates.
        </p>
      </div>

      <div className="space-y-4">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="email_notifications"
              type="checkbox"
              className="h-4 w-4 text-primary-600 border-secondary-300 rounded"
              defaultChecked
            />
          </div>
          <div className="ml-3">
            <label
              htmlFor="email_notifications"
              className="text-sm font-medium text-secondary-900 dark:text-white"
            >
              Email Notifications
            </label>
            <p className="text-sm text-secondary-500 dark:text-secondary-400">
              Receive email notifications about order updates and status
              changes.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="push_notifications"
              type="checkbox"
              className="h-4 w-4 text-primary-600 border-secondary-300 rounded"
              defaultChecked
            />
          </div>
          <div className="ml-3">
            <label
              htmlFor="push_notifications"
              className="text-sm font-medium text-secondary-900 dark:text-white"
            >
              Push Notifications
            </label>
            <p className="text-sm text-secondary-500 dark:text-secondary-400">
              Receive push notifications on your desktop or mobile device.
            </p>
          </div>
        </div>
      </div>
    </div>
    </PageWrapper>
  );
};

export default NotificationSettings